import React, { useState } from "react";
import { IconButton, Badge, Tooltip } from "@mui/material";
import ForumIcon from "@mui/icons-material/Forum";
import { useAuth } from "../../firebase/authContext";
import { useSocial } from "../../context/SocialContext";
import AuthModal from "../Auth/AuthModal";

export default function SocialButton({ size = "small", sx = {} }) {
  const { currentUser } = useAuth();
  const { openSocialModal, unreadCounts } = useSocial();
  const [authModalOpen, setAuthModalOpen] = useState(false);

  const handleClick = () => {
    if (!currentUser || currentUser.isGuest || currentUser.uid === "local_guest_user") {
      setAuthModalOpen(true);
      return;
    }
    openSocialModal(0);
  };

  const totalUnread = (unreadCounts?.unreadMessages || 0) + (unreadCounts?.pendingRequests || 0);

  return (
    <>
      <Tooltip title="主内好友与私信交流">
        <IconButton
          color="inherit"
          size={size}
          onClick={handleClick}
          sx={{ ...sx }}
          aria-label="主内私信与好友"
        >
          <Badge badgeContent={totalUnread} color="error" max={99}>
            <ForumIcon fontSize="small" />
          </Badge>
        </IconButton>
      </Tooltip>

      <AuthModal
        open={authModalOpen}
        onClose={() => setAuthModalOpen(false)}
      />
    </>
  );
}
